import { DialogProps } from "@mui/material";
import { ModalBasic } from "../../../../../../shared/components/ModalBasic";
import { CaseSolutionContent } from "./CaseSolutionContent";
import { TModalsIds } from "../../../../../../app/state/modalSlice/types";
import { useModalSelectors } from "../../../../../../app/state/modalSlice/hook/use-modal-selectors";
import { useAppSelector } from "../../../../../../services/redux/hooks/use-selector";
import {
  selectCaseSolution,
  selectSolutionLoading,
} from "../../../../redux/selectors";
import { LoadingText } from "../../../../../../common/LoadingText";
import styles from "./styles.module.css";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
  className?: string;
}

export const CaseSolutionModal = ({ closeModal }: Props) => {
  const caseSolutionModal = useModalSelectors("case_solution_modal");
  const caseSolution = useAppSelector(selectCaseSolution);
  const isSolutionLoading = useAppSelector(selectSolutionLoading);
  return (
    <ModalBasic
      open={caseSolutionModal.isOpen}
      title={"Промпт для решения"}
      onClose={() => closeModal("case_solution_modal")}
      closeModal={() => closeModal("case_solution_modal")}
      hasCloseButton
      hasHeaderPaddingBottom
    >
      <div className={styles["modal-body"]}>
        <div className={styles["scroll-wrapper"]}>
          {isSolutionLoading ? (
            <LoadingText text="Пожалуйста, подождите идёт генерация промпта" />
          ) : (
            <CaseSolutionContent
              solution={caseSolution}
              closeModal={closeModal}
            />
          )}
        </div>
      </div>
    </ModalBasic>
  );
};
